<template>
  <b-container fluid>
    <b-row>
      <b-col md="12">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title">{{ $t("sidebar.courses") }}</h4>
          </template>
          <template v-slot:headerAction>
            <b-button variant="primary" @click="$refs.modalCourses.show()">{{
              $t("app.new")
            }}</b-button>
          </template>
          <template v-slot:body>
            <b-row>
              <b-col sm="12" md="2" class="pr-1 mb-2">
                <v-select
                  :options="['5', '10', '20', '50', '100']"
                  v-model="filter.per_page"
                  size="sm"
                  @input="getData()"
                ></v-select>
              </b-col>
              <b-col cols="12" lg="3" md="3" sm="12" class="ml-auto mb-2">
                <v-select
                  v-model="filter.schoolPeriod"
                  :placeholder="$t('courses.period')"
                  :options="getPeriods"
                  :reduce="(period) => period.id"
                  label="name"
                  @input="getData()"
                >
                  <template #no-options="{}">
                    {{ $t("app.not-found") }}...
                  </template>
                </v-select>
              </b-col>
              <b-col cols="12" lg="3" md="3" sm="12" class="ml-auto mb-2">
                <v-select
                  v-model="filter.grade"
                  :reduce="(grade) => grade.id"
                  :placeholder="$t('courses.grade')"
                  :options="getGrades"
                  label="name"
                  @input="getData()"
                >
                  <template #no-options="{}">
                    {{ $t("app.not-found") }}...
                  </template>
                </v-select>
              </b-col>
              <b-col lg="3" md="3" sm="12" class="ml-auto mb-2">
                <b-form-input
                  :disabled="
                    !Array.isArray(getCourses.data) ||
                    (getCourses.data.length === 0 && coursesLoading === false)
                  "
                  v-model="filter.search"
                  type="search"
                  :placeholder="$t('app.search')"
                ></b-form-input>
              </b-col>

              <b-col md="12" class="table-responsive">
                <b-table
                  class="table mb-0 table-borderless"
                  :items="getCourses.data"
                  :fields="columns"
                  :per-page="getCourses.per_page"
                  :busy="
                    !Array.isArray(getCourses.data) ||
                    getCourses.data.length === 0
                      ? true
                      : false || coursesLoading == true
                  "
                  @filtered="onFiltered"
                >
                  <template #table-busy>
                    <div class="text-center text-danger my-2">
                      <div v-if="coursesLoading">
                        <b-spinner type="grow" class="align-middle"></b-spinner>
                        <strong>{{ $t("app.loading") }}...</strong>
                      </div>
                      <span class="h5" v-else>{{ $t("app.not-found") }}</span>
                    </div>
                  </template>

                  <template v-slot:cell(action)="data">
                    <b-button
                      variant=" iq-bg-info rounded"
                      class="mr-1"
                      size="sm"
                      @click="
                        $router.push({
                          name: 'administration.show-courses',
                          params: { id: data.item.id },
                        })
                      "
                      ><i class="ri-eye-line ml-1"></i
                    ></b-button>
                    <b-button
                      variant=" iq-bg-warning rounded"
                      class="mr-1"
                      size="sm"
                      @click="$refs.modalCourses.show(data.item)"
                      ><i class="ri-ball-pen-fill ml-1"></i
                    ></b-button>
                    <b-button
                      @click="deleteItem(data.item.id)"
                      variant=" iq-bg-danger rounded"
                      size="sm"
                      ><i class="ri-delete-bin-line ml-1"></i
                    ></b-button>
                  </template>
                </b-table>
                <b-pagination
                  class="mt-3 float-right"
                  v-model="filter.page"
                  :total-rows="getCourses.total"
                  :per-page="getCourses.per_page"
                  first-number
                  pills
                  size="sm"
                  @change="getData"
                ></b-pagination>
                <p class="mt-3">
                  {{ $t("app.registers") }} {{ getCourses.to }}
                  {{ $t("app.of") }} {{ getCourses.total }}. Total
                  {{ getCourses.total }}
                </p>
              </b-col>
            </b-row>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <modal-form ref="modalCourses" @refresh="getData()" />
  </b-container>
</template>
<script>
import { core } from "@/config/pluginInit";
import modalForm from "./modalForm.vue";
import { mapActions, mapGetters } from "vuex";
import _ from "lodash";

export default {
  name: "Courses",
  components: {
    modalForm,
  },
  mounted() {
    core.index();
    this.debouncedGetAnswer = _.debounce(this.getData, 500);
    this.getData();
    this.fetchPeriods();
    this.fetchGrades();
  },
  watch: {
    "filter.search": {
      handler() {
        this.debouncedGetAnswer();
      },
    },
  },
  methods: {
    ...mapActions({
      fetchCourses: "fetchCourses",
      deleteCourses: "deleteCourses",
      fetchPeriods: "fetchPeriods",
      fetchGrades: "fetchGrades",
    }),
    getData(page = 1) {
      this.filter.page = page;
      this.fetchCourses(this.filter);
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    deleteItem(id) {
      this.$bvModal
        .msgBoxConfirm(this.$t("app.body-confirm-delete"), {
          title: this.$t("app.title-confirm-delete"),
          size: "sm",
          buttonSize: "sm",
          okVariant: "success rounded",
          cancelVariant: "outline-danger rounded",
          okTitle: this.$t("app.yes"),
          cancelTitle: this.$t("app.not"),
          headerClass: "text-center",
          bodyClass: "text-center text-danger",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then(async (value) => {
          if (value) {
            const resp = await this.deleteCourses(id);
            this.getData();
            core.showSnackbar("success", this.$t("app.delete-success"));
          }
        })
        .catch((err) => {
          // An error occurred
        });
    },
  },
  data() {
    return {
      filter: {
        paginate: true,
        page: 1,
        per_page: 10,
        search: null,
        schoolPeriod: null,
        grade: null,
      },
      totalRows: 1,
    };
  },
  computed: {
    ...mapGetters({
      getCourses: "getCourses",
      coursesLoading: "coursesLoading",
      getPeriods: "getPeriods",
      getGrades: "getGrades",
    }),
    columns() {
      return [
        { label: this.$t("courses.name"), key: "name", class: "text-center" },
        {
          label: this.$t("courses.grade"),
          key: "grade.name",
          class: "text-center",
        },
        {
          label: this.$t("courses.period"),
          key: "schoolPeriod.name",
          class: "text-center",
        },
        { label: this.$t("app.action"), key: "action", class: "text-center" },
      ];
    },
  },
};
</script>
